import { NETWORK_OPERATOR_TO_PFLEGENDE_BU, PFLEGENDE_BU } from 'global/constants';

import { getTenantId } from 'utils/tenantUtil';

export const mapNetworkOperatorsToPflegendeBU = (operators = []) =>
  operators.map((operator) => NETWORK_OPERATOR_TO_PFLEGENDE_BU[operator] || operator);

const getConsentOperatorIds = (consentGranted, operators) => {
  const portalBusinessUnits = Object.values(PFLEGENDE_BU[getTenantId()]);
  const portalOperatorIds = Object.values(NETWORK_OPERATOR_TO_PFLEGENDE_BU).filter((id) =>
    portalBusinessUnits.includes(id)
  );
  const additionalOperatorIds = mapNetworkOperatorsToPflegendeBU(operators).filter(
    (id) => !portalOperatorIds.includes(id)
  );

  return [...new Set([...additionalOperatorIds, ...(consentGranted ? portalOperatorIds : [])])];
};

export const createPatchEinwilligungByInstallerIdData = (
  dsgvoAddressPublic,
  dsgvoCanSendMail,
  informationOperators = [],
  addressOperators = []
) => ({
  input: {
    zuAdressveroeff: dsgvoAddressPublic ? 'Ja' : 'Nein',
    zuInfoversand: dsgvoCanSendMail ? 'Ja' : 'Nein',
    informationOperators: getConsentOperatorIds(dsgvoCanSendMail, informationOperators),
    addressOperators: getConsentOperatorIds(dsgvoAddressPublic, addressOperators),
  },
});
